import * as React from "react";
import Select from 'react-select';
import './SelectSingle.scss'
interface  ISelectSigle {
  options: any [], 
  onChange: (ev: any) => void,
  value: any, 
  placeholder: string,
  inputChange?: (ev: any) => void
}

export default function SelectSingle(props: ISelectSigle) {

  const {options, onChange, value, placeholder, inputChange} = props 
  
  let timer = 0 as any;
  const inputChangeEv = (e: string, event: any) => {
    clearTimeout(timer)
    if (event.action !== "input-change" && event.action !== 'input-blur') {
      return
    }
    if (inputChange) {
      timer = setTimeout(() => {
        inputChange(e)
      }, 500)
    }
  }
  return (
      <Select className="select-single"
        value={value}
        defaultValue={value}
        isClearable={'clear'}
        onChange={onChange}
        options={options} 
        placeholder={placeholder}
        noOptionsMessage={() => 'Não encontrado dados'} 
        onInputChange={(e:any, actionMeta: any) => inputChangeEv(e, actionMeta)}   
      />
    );
}


// WEBPACK FOOTER //
// ./src/component/selectsingle/SelectSingle.tsx